import api from './api';

export const liveCameraService = {
  getActiveLiveCameraInfo: () => api.get('/live-camera/active'),
  getAllLiveCameraInfo: () => api.get('/live-camera'),
  getLiveCameraInfoById: (id) => api.get(`/live-camera/${id}`),
  createLiveCameraInfo: (data) => api.post('/live-camera', data),
  updateLiveCameraInfo: (id, data) => api.put(`/live-camera/${id}`, data),
  deleteLiveCameraInfo: (id) => api.delete(`/live-camera/${id}`),
  setActiveLiveCameraInfo: (id) => api.put(`/live-camera/${id}/activate`),
};
